<script>
  import { Button, Spinner } from 'flowbite-svelte';
  export let loading = false;
  export let disabled = false;
</script>

<Button
  size="xl"
  color="blue"
  disabled={loading || disabled}
  {...$$restProps}
  on:click
  >{#if loading}<Spinner size="4" color="blue" class="mr-1" />{/if}<slot
  /></Button
>
